// Error banner reveal helper for config load failures

declare global {
  interface Window {
    __revealConfigErrorBanner?: (msg?: string) => void;
  }
}

window.__revealConfigErrorBanner = function (msg?: string): void {
  const banner = document.getElementById('config-error-banner');
  if (banner) {
    banner.textContent =
      '⚠️ Configuration Error: ' + (msg || 'Portal cannot start. Check console for details.');
    banner.hidden = false;
  }
};

// Early proactive config fetch to surface missing config.json before main bundle executes
(function (): void {
  try {
    fetch('/config.json', { cache: 'no-store' })
      .then(function (r: Response): void {
        if (r.status === 404) {
          console.warn('[portal:config] config.json missing; using embedded defaults.');
          window.__revealConfigErrorBanner('Portal cannot start. (missing config.json)');
          return;
        }
        if (!r.ok) {
          window.__revealConfigErrorBanner('Portal cannot start. (missing config.json)');
        }
      })
      .catch(function (): void {
        window.__revealConfigErrorBanner('Portal cannot start. (missing config.json)');
      });
  } catch (_e) {
    window.__revealConfigErrorBanner('Portal cannot start. (missing config.json)');
  }
})();

export {};
